import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Error404Icon } from '../../../../assets/icons/error-pages/error404.svg';
import CommonErrorPage from '../CommonErrorPage/CommonErrorPage';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <CommonErrorPage
      errorTone="notFound"
      errorIcon={Error404Icon}
      statusCode="404"
      title={t('errorPages.notFound.title')}
      description={t('errorPages.notFound.description')}
      buttonText={t('errorPages.notFound.goHome')}
    />
  );
};

export default NotFoundPage;
